// Note: The first file of a module here, must also register the module

import "./cancel.component";
import "./delete-account-dialog.component";
import "./essentials-dialog.component";
import "./feedback.component";
import "./help-option.component";
